<template>
  <button
    :class="[
      'inline-flex items-center justify-center transition-colors duration-300',
      sizeClasses,
      variantClasses,
      roundedClasses,
      {
        'opacity-50 cursor-not-allowed': disabled,
        'cursor-pointer': !disabled,
      },
      className,
    ]"
    :disabled="disabled"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <i v-if="icon" :class="['mdi', `mdi-${icon}`, iconClasses]"></i>
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: "Button",
    inheritAttrs: false,
    props: {
      // Visual variants
      variant: {
        type: String,
        default: "primary",
        validator: (value) =>
          [
            "primary",
            "secondary",
            "neutral",
            "danger",
            "success",
            "transparent",
          ].includes(value),
      },
      // Size variations
      size: {
        type: String,
        default: "md",
        validator: (value) => ["sm", "md", "lg"].includes(value),
      },
      // Border radius options
      rounded: {
        type: String,
        default: "md",
        validator: (value) =>
          ["none", "sm", "md", "lg", "full"].includes(value),
      },
      // Icon support
      icon: {
        type: String,
        default: "",
      },
      // Icon positioning and sizing
      iconClasses: {
        type: String,
        default: "",
      },
      // Additional classes
      className: {
        type: String,
        default: "",
      },
      // Disabled state
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      sizeClasses() {
        return {
          sm: "px-3 py-1.5 text-sm gap-2",
          md: "px-4 py-2 text-base gap-2",
          lg: "px-6 py-3 text-lg gap-2",
        }[this.size];
      },
      variantClasses() {
        const variants = {
          primary:
            "bg-[#27bdf4] hover:bg-[#1da8dc] active:bg-[#1797c5] text-white",
          secondary:
            "bg-neutral-900 hover:bg-neutral-950 active:bg-neutral-900 text-white",
          neutral:
            "bg-neutral-700 hover:bg-neutral-600 active:bg-neutral-500 text-white",
          danger: "bg-red-500 hover:bg-red-600 active:bg-red-700 text-white",
          success:
            "bg-green-500 hover:bg-green-600 active:bg-green-700 text-white",
          transparent: "bg-transparent hover:bg-neutral-900/50 text-white",
        };
        return variants[this.variant];
      },
      roundedClasses() {
        return {
          none: "rounded-none",
          sm: "rounded",
          md: "rounded-md",
          lg: "rounded-lg",
          full: "rounded-full",
        }[this.rounded];
      },
    },
  };
</script>
